import React from "react";
import classnames from 'classnames';

import {dispatch} from '@wordpress/data';
import {__, sprintf} from "@wordpress/i18n";

import {RemovableChip} from '@woocommerce/blocks-components';
import {CART_STORE_KEY} from '@woocommerce/block-data';
import {formatPrice} from '@woocommerce/price-format';

import {useStoreCartVouchers} from "./use-store-cart-vouchers";
import './vouchers-list.scss';

const AppliedGiftCardsList = () => {
	const {removeAllGiftCards, getAppliedGiftCardsList, isLoading} = useStoreCartVouchers();

	const formWrapperClass = 'wc-block-components-totals-coupon__content';

	const onGiftCardRemove = (e, couponCode) => {
		e.preventDefault();

		removeAllGiftCards( couponCode )
			.finally(() => dispatch( CART_STORE_KEY ).invalidateResolutionForStore());
	}

	return (
		<div className={ formWrapperClass }>
			<div className={classnames(
				"wc-block-components-totals-vouchers__content",
				"wc-block-components-totals-gift-cards__content"
			)}>
				<span className="wp-block-woocommerce-cart-order-summary-heading-block wc-block-cart__totals-title">{
					__('Applied gift cards', 'voucherify')
				}</span>
				<div className={classnames(
					"wp-block-woocommerce-cart-order-summary-subtotal-block",
					"wc-block-components-totals-wrapper"
				)}>
					<div className="wc-block-components-totals-item">
						<ul className="wc-block-components-totals-discount__coupon-list">
							{getAppliedGiftCardsList().map(([couponCode, couponAmount], index) => (
								<RemovableChip
									key={ 'coupon-' + couponCode }
									className="wc-block-components-totals-discount__coupon-list-item"
									text={ <>{couponCode}: <span className={"amount-deducted"}>-{formatPrice(couponAmount * 100)}</span></> }
									screenReaderText={ sprintf(
										/* translators: %s Coupon code. */
										__( 'Gift card: %s', 'voucherify' ),
										couponCode
									) }
									disabled={ isLoading }
									onRemove={ (e) => onGiftCardRemove(e, couponCode) }
									radius="large"
									ariaLabel={ sprintf(
										/* translators: %s is a coupon code. */
										__(
											'Remove gift card "%s"',
											'voucherify'
										),
										couponCode
									) }
								/>
							))}
						</ul>
					</div>
				</div>
			</div>
		</div>
	);
}

export default AppliedGiftCardsList;
